
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.153","height":"23.935"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29569","data-name":"Path 29569","d":"M8.319 6.426v2.553h3.949l-.511 3.995H8.319v10.211H4.204V12.958H.75V8.963h3.438V6.02c0-3.409 2.088-5.27 5.136-5.27a30.192 30.192 0 013.079.165v3.558h-2.117c-1.652 0-1.968.8-1.968 1.952","fill":"none","stroke":"#5a677a","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    